export {
    default,
    type IconPointerListContentProps,
} from './IconPointerListContent';
